import React from 'react';
import { PolicyFromText } from '../../components/ui/PolicyFromText';
import { accessibilityStatement } from '../../data/policies/accessibility';
export function Accessibility() {
  return <PolicyFromText doc={accessibilityStatement} data-id="element-1130" data-mp="1tdj1lutfeurc" />;
}